<div class="container-fluid bg-primary-100 fadein">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-12">
        <h1 class="text-center mb-4">Tipos de operaciones</h1>
      </div>
      @for (ficha of operacionesData; track ficha) {
        <div class="col-lg-4 mb-3">
          <div class="shadow-8 p-4">
            <div class="row">
              <div class="col-2 d-none d-lg-flex d-xl-none align-items-center justify-content-center">
                <app-sellos [tipoOperacionCodigo]="ficha.tipoOperacionCodigo" [size]="50"></app-sellos>
              </div>
              <div class="col-3 d-flex d-lg-none d-xl-flex align-items-center justify-content-center">
                <app-sellos [tipoOperacionCodigo]="ficha.tipoOperacionCodigo" [size]="60"></app-sellos>
              </div>
              <div class="col">
                <p class="tabs">{{ficha.titulo}}</p>
                <p class="p2-bold primary-800 mb-0">
                {{ficha.tipoPerfil}}</p>
                <p class="p2-medium primary-800 mb-0">
                {{ficha.renta}}</p>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="mt-4 text-center">
        <a routerLink="/como-funciona" class="btn btn-primary">
          <span>Cómo funciona SEGO Factoring</span>
        </a>
    </div>
  </div>